import React, { useState } from 'react';
import CheckInTable from './CheckInTable';
import TimeSheetTable from './TimeSheetTable';
import { User } from './CheckInAlert'; // Re-using User type

interface OverviewMainProps {
    organizationId: string;
    users: User[];
}

const OverviewMain: React.FC<OverviewMainProps> = ({ organizationId, users }) => {
    const [activeSubTab, setActiveSubTab] = useState<'CheckIn' | 'TimeSheet'>('CheckIn');

    if (activeSubTab === 'CheckIn') {
        return (
            <CheckInTable
                organizationId={organizationId}
                users={users}
                onBack={() => { }} // No back button needed in main tab view
                activeTab="CheckIn"
                onTabChange={(tab) => setActiveSubTab(tab)}
            />
        );
    } else {
        return (
            <TimeSheetTable
                organizationId={organizationId}
                users={users}
                onBack={() => { }} // No back button needed in main tab view
                activeTab="TimeSheet"
                onTabChange={(tab) => setActiveSubTab(tab)}
            />
        );
    }
};

export default OverviewMain; // Force rebuild
